module.exports = __webpack_public_path__ + "img/69.d921cb9a.png";